import { DependencyList, EffectCallback, useEffect, useRef } from 'react';

/**
 * A hook that works like useEffect but skips the initial render.
 * Only runs the effect when dependencies change after the first render.
 *
 * @param effect - The effect callback to run on updates
 * @param deps - The dependency array
 */
export const useUpdateEffect = (effect: EffectCallback, deps?: DependencyList): void => {
  const isFirstRender = useRef(true);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    return effect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
};
